import { constants } from "@newsela/angelou";

const greyLight = constants.colors.ui.neutral[100];

export const wrapperCss = {
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center" as const,
  justifyContent: "start" as const,
  position: "relative" as const,
  padding: 0,
  margin: 0,
  gap: 10,
  width: "800px",
  height: "auto" as const,
  boxSizing: "border-box" as const,
  overflowY: "auto" as const,
};

export const formContainerCss = {
  width: "100%",
  padding: "0 32px",
  borderBottom: "1px solid" + greyLight,
  paddingBottom: "8px",
};

export const titleCss = {
  fontSize: "24px",
  lineHeight: "31,92px",
  fontWeight: "700",
};
